import { motion } from "framer-motion";
import { Hammer, Wrench, Ruler, ClipboardList } from "lucide-react";

const ICONS = [Hammer, Wrench, Ruler, ClipboardList];

export const Services = ({ t }) => {
  return (
    <section id="leistungen" data-testid="services-section" className="section-pad bg-[#0b0b0e] scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <p data-testid="services-overline" className="font-mono-accent text-xs uppercase tracking-[0.3em] text-pink-brand mb-4">
            {t.services.overline}
          </p>
          <h2 data-testid="services-title" className="font-display font-bold text-4xl md:text-5xl text-white tracking-tight">
            {t.services.title}
          </h2>
          <p className="mt-4 max-w-2xl text-base md:text-lg text-neutral-400">{t.services.sub}</p>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 border border-white/10" data-testid="services-grid">
          {t.services.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`service-card-${i}`}
                className="group relative p-8 md:p-12 border-white/10 border-b md:border-b-0 md:odd:border-r md:[&:nth-child(-n+2)]:border-b hover:bg-white/[0.03] transition-colors duration-300"
              >
                <div className="flex items-start justify-between">
                  <Icon size={28} className="text-pink-brand" strokeWidth={1.5} />
                  <span className="font-mono-accent text-xs text-neutral-600">0{i + 1}</span>
                </div>
                <h3 className="mt-8 font-display text-2xl md:text-3xl font-semibold text-white group-hover:text-pink-brand transition-colors duration-300">
                  {item.title}
                </h3>
                <p className="mt-4 text-neutral-400 leading-relaxed text-sm md:text-base">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
